/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Pages_SubtitleInputs */

const en_mobile_scan_pages_subtitle = /** @type {(inputs: Mobile_Scan_Pages_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take photos of physical pages to listen`)
};

const es_mobile_scan_pages_subtitle = /** @type {(inputs: Mobile_Scan_Pages_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma fotos de páginas físicas para escucharlas`)
};

/**
* | output |
* | --- |
* | "Take photos of physical pages to listen" |
*
* @param {Mobile_Scan_Pages_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_pages_subtitle = /** @type {((inputs?: Mobile_Scan_Pages_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Pages_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_pages_subtitle(inputs)
	return en_mobile_scan_pages_subtitle(inputs)
});